import http from '@/utils/http';
import createFiltroInteligenciaTerritorial from '@/models/FiltroInteligenciaTerritorial';
import i18n from '@/main';

const baseUrl = '/inteligencia-territorial';

export default {
    pesquisar(filtro) {
        return http.get({
            url: baseUrl + `/pesquisa-inteligente/${filtro}`,
            lockScreen: false
        });
    },

    filtrarAreaTotalPorCARs(body) {
        if (body.codigosCulturas) {
            if (!Array.isArray(body.codigosCulturas)) {
                body.codigosCulturas = [body.codigosCulturas];
            }
        }
        return http.post({
            url: baseUrl + '/areaTotal',
            data: createFiltroInteligenciaTerritorial(body).toRequest(),
            lockScreen: false
        });
    },

    filtrarAreaTotalPorMunicipios(body) {
        if (body.codigosCulturas) {
            if (!Array.isArray(body.codigosCulturas)) {
                body.codigosCulturas = [body.codigosCulturas];
            }
        }
        return http.post({
            url: baseUrl + '/municipios/ar' +
                'eaTotal',
            data: createFiltroInteligenciaTerritorial(body).toRequest(),
            lockScreen: false
        });
    },

    buscarCamadas(camadas) {
        return http.get({
            url: baseUrl + `/listar-camadas?camadas=${camadas}`,
            lockScreen: true
        });
    },

    buscarCidadesPorUF(uf, tipoGrafico) {
        return http.get({
            url: `/camadas/municipios/${uf}?tipoGrafico=${tipoGrafico}&cicloSafra=1`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.carregandoVisualizacaoDeMunicipios')
        });
    },
    buscarRankingCARPorMunicipio(idMunicipio, tipoGrafico) {
        return http.get({
            url: baseUrl + `/cars/ranking/${tipoGrafico}?tipoAgrupamento=MUNICIPIO&idMunicipio=${idMunicipio}`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoOsCarsDoMunicipio')
        });
    },

    buscaRankingPaisOuEstadoPorFiltro(tipoGrafico, tipoAgrupamento = 'PAIS', uf, idMunicipio, cicloSafra) {
        let url = baseUrl + `/cars/ranking/${tipoGrafico}` + '?tipoAgrupamento=' + tipoAgrupamento;

        if (uf !== null && uf !== undefined) {
            url += '&uf=' + uf;
        }

        if (idMunicipio !== null && idMunicipio !== undefined) {
            url += '&idMunicipio=' + idMunicipio;
        }

        if (cicloSafra !== null && cicloSafra !== undefined) {
            url += '&cicloSafra=' + cicloSafra;
        }

        return http.get({
            url: url,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoFiltroCoropletico')
        });
    },
    async buscarAreasPlantadasMapBiomas(anos = '2022', codigosCulturas = 'SOJA', codigoImovel = null) {
        let url = baseUrl + `/areas-plantadas/mapbiomas` + '?anos=' + anos;

        if (codigosCulturas !== null && codigosCulturas !== undefined) {
            url += '&codigosCulturas=' + codigosCulturas;
        }

        if (codigoImovel !== null && codigoImovel !== undefined) {
            url += '&codigoImovel=' + codigoImovel;
        }

        try {
            return await http.get({
                url: url,
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.carregandoDadosDosGraficos')
            });
        } catch (err) {
            throw err;
        }
    },
    async buscarDadosClimaticos(body, camada = 'PRECIPITACAO') {
        let url = baseUrl + '/climaticos/porCamada' + '?camada=' + camada;

        try {
            return await http.post({
                url: url,
                data: body,
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.carregandoDadosClimaticos')
            });
        } catch (err) {
            throw err;
        }
    }
};
